import { useState } from "react";
import type { Student, School } from "../types";
import { StudentList } from "./StudentList";
import { StudentPreferences } from "./StudentPreferences";
import "./StudentsView.css";

interface StudentsViewProps {
  students: Student[];
  schools: School[];
  schoolId: number;
  onStudentsChange: () => void;
  canEdit?: boolean;
}

export function StudentsView({
  students,
  schools,
  schoolId,
  onStudentsChange,
  canEdit = true,
}: StudentsViewProps) {
  const [selectedStudent, setSelectedStudent] = useState<Student | null>(null);

  // Show only the list until a student is selected; then show split view
  if (!selectedStudent) {
    return (
      <div className="students-view-layout">
        <div className="students-view-left">
          <StudentList
            students={students}
            schoolId={schoolId}
            schools={schools}
            onStudentsChange={onStudentsChange}
            onSelectStudent={setSelectedStudent}
            selectedStudentId={null}
            canEdit={canEdit}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="students-view-layout">
      <div className="students-view-left">
        <StudentList
          students={students}
          schoolId={schoolId}
          schools={schools}
          onStudentsChange={onStudentsChange}
          onSelectStudent={setSelectedStudent}
          selectedStudentId={selectedStudent.id}
          canEdit={canEdit}
        />
      </div>
      <div className="students-view-right">
        <StudentPreferences
          students={students}
          onPreferencesChange={onStudentsChange}
          selectedStudent={selectedStudent}
          hideHeader
        />
      </div>
    </div>
  );
}
